'use es6';

import http from 'conversations-http/clients/http';
export const promptWasShown = ({
  promptType
}) => http.put(`cv/inbox/settings/v1/user-prompts/viewed`, {
  query: {
    promptType
  }
});